import React, { useState, useEffect, useContext, useRef } from 'react'
import { ReactInternetSpeedMeter } from 'react-internet-meter'
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import InputAdornment from '@mui/material/InputAdornment';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ApartmentIcon from '@mui/icons-material/Apartment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkIcon from '@mui/icons-material/Work';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import TimePicker from '@mui/lab/TimePicker';
import CloseIcon from '@mui/icons-material/Close';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import apiFetch from '../utils/apiFetch';

import Timer from './Timer';
import './ScheduleInterviewUI.css';

import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { UserContext } from './UserContext';

import { MenuItem, Select, Button, TextField, InputLabel, FormControl, Typography, Modal, Box, Container, Autocomplete } from '@mui/material';
import ApplicantPopup from './ApplicantPopup';
import InterviewApplicantPopup from './InterviewApplicantPopup';
import EmailTemplatesPopup from './EmailTemplatesPopup';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditJobs from './EditJobs';
import WorkPreferencesScheduleInterviewUI from './WorkPreferencesScheduleInterviewUI';
//import { google } from "googleapis";

const style4 = {

  position: 'relative',
  margin: "auto",
  height: "auto",
  minWidth: 375,
  maxWidth: 400,
  scrollY: "auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',

};

const NearbyLocations = {

  position: 'relative',
  margin: "auto",
  height: "auto",
  minWidth: 600,
  maxWidth: 600,
  scrollY: "auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',

};

const JdModal = {
  position: 'relative',
  margin: "auto",
  height: "auto",
  minWidth: 250,
  maxWidth: 400,
  scrollY: "auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',

};


const rounds = [
  { label: 'HR Screening' },
  { label: 'Verification' },
  { label: 'Client Round' },
]

const locations = [
  { label: 'Mobile Call' },
  { label: 'Video Call' },
  { label: 'Diamond District' },
  { label: 'Nagawara' },
  { label: 'Indiranagar' },
]
const ScheduleInterviewUI = (props) => {

  const [interviewId, setInterviewId] = useState("");
  const [msgInterviewId, setMsgInterviewId] = useState("");
  const [appliedJob, setAppliedJob] = useState();
  const [vacancies, setVacancies] = useState();
  const [jobsDataProps, setJobsDataProps] = useState();
  const [round, setRound] = useState("");
  const [interViewerName, setInterViewerName] = useState("");
  const [interViewDate, setInterViewDate] = React.useState(new Date().toLocaleDateString());
  const [interViewTime, setInterViewTime] = React.useState(new Date().toLocaleTimeString().slice(0, 5));
  const [timeDate, setTimeDate] = React.useState(new Date().toLocaleDateString())
  const [interViewLocation, setInterViewLocation] = useState("Mobile Call");
  const [companyName, setCompanyName] = useState();
  const [name, setName] = useState();
  const [status, setStatus] = useState();
  const [applicantId, setApplicantId] = useState();
  const [jobId, setJobId] = React.useState();
  const [jobTitle, setJobTitle] = React.useState();
  const [mobile, setMobile] = useState();
  const [result, setResult] = useState();
  const [feedback, setFeedback] = useState("");
  const { user, setUser } = useContext(UserContext);
  const [companies, setCompanies] = useState();
  const [prevfeedback, setPrevFeedback] = useState("");
  const [language, setLanguage] = useState("");
  const [bookMark, setBookMark] = useState(false);
  const [bookMarkCmts, setBookMarkCmts] = useState("");
  const [hrName, setHRName] = useState("");
  const [candidateRounds, setCandidateRounds] = useState([])
  const [nextinterviewDate, setNextInterviewDate] = useState(React.useState(new Date().toLocaleDateString()));
  const [roundResult, setRoundResult] = useState("");
  const [openTime, setOpenTime] = useState(0);
  const [previousCurrent, setPreviousCurrent] = useState(0)
  const [expectedSalary, setExpectedSalary] = useState(0)
  const [referalName, setReferalName] = useState("")
  const [referalNumber, setReferalNumber] = useState("")
  const [referalGender, setReferalGender] = useState("male")
  const [createdbyid, setCreatedbyId] = useState("")
  const [createdbyname, setCreatedbyName] = useState("")
  const [mobileStatus, setMobileStatus] = useState("")
  const [mail, setMail] = useState("");
  const [whatsappStatus, setWhatsappStatus] = useState(true);
  const [sendEmail, setSendEmail] = useState(false);
  const [openJDModel, setOpenJDModel] = useState(false);
  const [city, setCity] = useState("");
  const [area, setArea] = useState("");
  const [education, setEducation] = useState("");
  const [areasOfinterview, setAreasOfinterview] = useState([])
  const [Dob, setDob] = React.useState(new Date());
  const [expYears, setExpYears] = useState(0);
  const [openApplicant, setOpenApplicant] = useState(false);
  const [openEmailTemplate, setOpenEmailTemplate] = useState(false);
  const [expMonth, setExpMonths] = useState(0);
  const [openScheduler, setOpenScheduler] = useState(false)
  const uploadedCount = useRef(0);
  // const [intervalId,setIntervalId] = useState(0);
  const [resumeUrl, setResumeUrl] = useState("");
  const [noticePeriod, setNoticePeriod] = useState(0)
  const [totalExperience, setTotalExperience] = useState(0);
  const [egr, setEgr] = useState("");
  const [cmr, setCmr] = useState("");
  const [hRNames, setHRNames] = useState([]);
  const [jobDescription, setJobDescription] = useState("");
  const [keySkills, setKeySkills] = useState("");
  const [openLocationModal, setOpenLocationModal] = React.useState(false);
  const [companyCoordinates, setCompanyCoordinates] = useState([]);
  const [openNext, setOpenNext] = useState(true)
  const [voiceProcess, setVoiceProcess] = useState(true)
  const [nonVoiceProcess, setNonVoiceProcess] = useState(true)
  const [workFromHome, setWorkFromHome] = useState(true)
  const [workFromOffice, setWorkFromOffice] = useState(true)
  const [partTime, setPartTime] = useState(true)
  const [fullTime, setFullTime] = useState(true)
  const [nightShift, setNightShift] = useState(true)
  const [dayShift, setDayShift] = useState(true)
  const [companyTransportDay, setCompanyTransportDay] = useState(true)
  const [companyTransportNight, setCompanyTransportNight] = useState(true)
  const [ownTransport, setOwnTransport] = useState(true)
  const [willingToRelocate, setWillingToRelocate] = useState(true)
  const [mapUrl, setMapUrl] = useState("");
  const [candidatePreference, setCandidatePreference] = useState({});
  const [jobExperience, setJobExperience] = useState(0);
  const [wifiSpeed, setWifiSpeed] = useState(0);
  const intervalRef = useRef(null);




  // 1️⃣ Initial data fetching
  useEffect(() => {
    const fetchInitialData = async () => {
      await getCompanies();
      await getUsers();
      await getLocations();
    };
    fetchInitialData();
  }, []);

  // 2️⃣ Fetch interview rounds when applicantId changes
  useEffect(() => {
    if (applicantId) {
      getInterviewRounds();
    }
  }, [applicantId]);

  // 3️⃣ Populate interview data when props.interview or companies change
  useEffect(() => {
    if (!props.interview) return;

    const populateInterview = async () => {
      const interview = props.interview;
      const companyParts = interview.companyname.split(" - ");
      // setCompanyName(companyParts.length === 2 ? interview.companyname : null);
      if (companyParts.length === 2) await getOfficeVacancies(companyParts[0], companyParts[1]);

      setApplicantId(interview.applicantid);
      setJobId(interview.jobid);
      setInterviewId(interview.id);
      setCreatedbyId(interview.createdbyid);
      setCreatedbyName(interview.createdbyname);
      setName(interview.name);
      setInterViewerName(interview.interviewername || user.name);
      setInterViewDate(interview.interviewdate || new Date().toLocaleDateString());

      // Handle interview time
      let timeValue = interview.interviewtime || new Date().toTimeString().slice(0, 5);
      if (interview.interviewtime && interview.interviewtime.length >= 6) {
        timeValue = new Date(interview.interviewtime).toTimeString().slice(0, 5);
      }
      setInterViewTime(timeValue);

      // Combine date & time for TimeDate
      if (interview.interviewdate && interview.interviewtime) {
        const [hours, minutes] = interview.interviewtime.split(":").map(Number);
        const totalMinutes = hours * 60 + minutes + 330; // adjust timezone
        const interviewDateTime = new Date(new Date(interview.interviewdate).setMinutes(totalMinutes))
          .toISOString()
          .slice(0, 16);
        setTimeDate(interviewDateTime);
      } else {
        const defaultTime = new Date().setMinutes(new Date().getMinutes() + 330);
        setTimeDate(new Date(defaultTime).toISOString().slice(0, 16));
      }

      setRound(interview.rounds);
      setInterViewLocation(interview.interviewlocation !== "undefined" ? interview.interviewlocation : "");
      setFeedback("");
      setPrevFeedback(interview.feedback !== "undefined" ? interview.feedback : "");
      setBookMark(interview.bookmark ?? false);
      setBookMarkCmts(interview.bookmarkcomment !== "undefined" ? interview.bookmarkcomment : "");
      setResult(interview.status);
      setMobile(interview.mobile);
      setMail(interview.mail);


      setJobTitle(interview.jobtitle);
      setCmr(interview.communicationrating !== "undefined" ? parseInt(interview.communicationrating) : "");
      setEgr(interview.englishrating !== "undefined" ? parseInt(interview.englishrating) : "");
      setHRName(interview.hrname);

      // Set next interview date based on role & round
      if (interview.rounds === "Client Round") {
        setNextInterviewDate(new Date(new Date().setHours(15, 30)).toISOString().slice(0, 16));
      } else if (Number(user.accesstype) >= 3) {
        setNextInterviewDate(new Date(new Date().setHours(41, 30)).toISOString().slice(0, 16)); // 2490 minutes
      } else {
        setNextInterviewDate(new Date(new Date().setMinutes(new Date().getMinutes() + 330)).toISOString().slice(0, 16));
      }
    };

    populateInterview();
  }, [companies, props.interview?.id, props.interview?.feedback]);

  // 4️⃣ Scheduler logic & timer
  useEffect(() => {
    setOpenScheduler(props.open);

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (props.open) {
      getLanguages();
      if (Number(user.accesstype) < 3 && props.interview?.id) {
        timer("start");
        intervalRef.current = setInterval(() => timer("active10"), 10000);
      }
    } else {
      timer("stop");
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [props.open, props.interview?.id, props.interview?.feedback, user.accesstype]);

  // 5️⃣ Empty effect placeholder (could be removed if not needed)
  // useEffect(() => { }, [openTime, companyName]);

  // 6️⃣ Message handling
  useEffect(() => {
    if (!props.openMsg) return;

    setOpenScheduler(props.openMsg);

    const msg = props.interviewMsg;
    if (!msg) return;

    setApplicantId(msg._id);
    setRound(msg.latestinterviewround && msg.latestinterviewround !== "undefined" ? msg.latestinterviewround : "");
    setLanguage(msg.languages && msg.languages !== "undefined" ? msg.languages : "");
    setPreviousCurrent(msg.currentSalary && msg.currentSalary !== "undefined" ? msg.currentSalary : "");
    setExpectedSalary(msg.expectedSalary && msg.expectedSalary !== "undefined" ? msg.expectedSalary : "");
    setCity(msg.city && msg.city !== "undefined" ? msg.city : "");
    setArea(msg.area && msg.area !== "undefined" ? msg.area : "");
    setEducation(msg.education && msg.education !== "undefined" ? msg.education : "");
    setResumeUrl(msg.resumeUrl && msg.resumeUrl !== "undefined" ? msg.resumeUrl : "");
    setExpYears(msg.experience && msg.experience !== "undefined" ? Math.floor(msg.experience / 12) : 0);
    setExpMonths(msg.experience && msg.experience !== "undefined" ? msg.experience % 12 : 0);
    setNoticePeriod(msg.noticePeriod && msg.noticePeriod !== "undefined" ? msg.noticePeriod : 0);

    // Preferences parsing with default true
    const prefs = msg.preferences ? JSON.parse(msg.preferences) : {};
    setVoiceProcess(prefs.voiceProcess ?? true);
    setNonVoiceProcess(prefs.nonVoiceProcess ?? true);
    setWorkFromHome(prefs.workFromHome ?? true);
    setWorkFromOffice(prefs.workFromOffice ?? true);
    setPartTime(prefs.partTime ?? true);
    setFullTime(prefs.fullTime ?? true);
    setNightShift(prefs.nightShift ?? true);
    setDayShift(prefs.dayShift ?? true);
    setCompanyTransportDay(prefs.companyTransportDay ?? true);
    setCompanyTransportNight(prefs.companyTransportNight ?? true);
    setOwnTransport(prefs.ownTransport ?? true);
    setWillingToRelocate(prefs.willingToRelocate ?? true);

    if (msg.latestinterviewid) {
      setInterviewId(msg.latestinterviewid);
      getMessagedInterview(msg.latestinterviewid);
    }
  }, [props.interviewMsg, props.openMsg]);

  const preferencesMap = {
    voiceProcess: setVoiceProcess,
    nonVoiceProcess: setNonVoiceProcess,
    workFromHome: setWorkFromHome,
    workFromOffice: setWorkFromOffice,
    partTime: setPartTime,
    fullTime: setFullTime,
    nightShift: setNightShift,
    dayShift: setDayShift,
    companyTransportDay: setCompanyTransportDay,
    companyTransportNight: setCompanyTransportNight,
    ownTransport: setOwnTransport,
    willingToRelocate: setWillingToRelocate,
  };

  const setPreference = (key, value) => {
    if (preferencesMap[key]) preferencesMap[key](value);
  };

  const getValue = (val, fallback = "") => {
    return val === undefined || val === "undefined" || val === null ? fallback : val;
  };

  const fetchData = async (url, params = {}) => {
    try {
      const res = await apiFetch(url, params);
      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || "Request failed");
      }
      return await res.json();
    } catch (err) {
      props.showAlert(String(err.message || err), "error");
      return null;
    }
  };


  const getMessagedInterview = async (latestintwID) => {
    try {
      // Build API URL
      const apiURL = `${process.env.REACT_APP_API_URL}/interview/getlatestinterview/${latestintwID}`;

      // Fetch API
      const res = await apiFetch(apiURL, {
        method: "GET",
        headers: {
          authtoken: localStorage.getItem("loggedintoken")
        }
      });

      // Parse response
      const data = res.status === 200 ? await res.json() : await res.text();

      if (!data.data) {
        props.showAlert("" + (data.message || data), "error");
        return;
      }

      const repo = data.data;

      // Set basic info
      setInterviewId(repo._id);
      setName(repo.name);
      setInterViewerName(repo.interviewername || user.name);
      setInterViewDate(repo.interviewdate || new Date().toLocaleDateString());

      // Handle interview time
      let interviewTime = repo.interviewtime;
      //setCompanyName(repo.companyname.includes(" - ") ? repo.companyname : null);

      // Fetch office vacancies if company name is valid
      const companyParts = repo.companyname.split(" - ");
      if (companyParts.length === 2) {
        await getOfficeVacancies(companyParts[0], companyParts[1]);
      }
      if (interviewTime) {
        if (interviewTime.length < 6) {
          setInterViewTime(interviewTime);
        } else {
          setInterViewTime(new Date(interviewTime).toTimeString().slice(0, 5));
        }
      } else {
        setInterViewTime(new Date().toTimeString().slice(0, 5));
      }

      // Combine date and time into ISO string
      if (repo.interviewdate && repo.interviewtime) {
        const [hours, minutes] = repo.interviewtime.split(':').map(Number);
        const interviewDate = new Date(repo.interviewdate);
        interviewDate.setHours(hours, minutes);
        setTimeDate(interviewDate.toISOString().slice(0, 16));
      } else {
        // Default to current time + 5h30m (IST)
        const now = new Date();
        now.setMinutes(now.getMinutes() + 330);
        setTimeDate(now.toISOString().slice(0, 16));
      }

      // Other interview details
      setRound(repo.rounds);
      setInterViewLocation(repo.location || "");
      setFeedback("");
      setPrevFeedback(repo.feedback || "");
      setBookMark(repo.bookmark ?? false);
      setBookMarkCmts(repo.bookmarkcomment || "");
      setResult(repo.status);
      setRoundResult(repo.status);
      setMobile(repo.mobile);


      setCmr(repo.communicationRating ? parseInt(repo.communicationRating) : "");
      setEgr(repo.englishRating ? parseInt(repo.englishRating) : "");
      setJobId(repo.jobId);
      setJobTitle(repo.jobtitle);
      setHRName(repo.hrname);

      // Calculate next interview date
      let nextInterviewDate = new Date();
      if (repo.rounds === "Client Round") {
        nextInterviewDate.setHours(15, 30); // example 3:30 PM
      } else if (Number(user.accesstype) >= 3) {
        nextInterviewDate.setHours(8, 30); // example 8:30 AM next day
        nextInterviewDate.setDate(nextInterviewDate.getDate() + 1);
      } else {
        nextInterviewDate.setMinutes(nextInterviewDate.getMinutes() + 330); // current + 5h30m
      }
      setNextInterviewDate(nextInterviewDate.toISOString().slice(0, 16));

    } catch (err) {
      props.showAlert('' + err, "error");
    }
  };


  const getLocations = async () => {
    let apiURL = process.env.REACT_APP_API_URL + "/locations/getlocations"
    let apiParams = {
      method: "GET",
      headers: {
        authtoken: localStorage.getItem("loggedintoken")
      }

    };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {

          setAreasOfinterview(repos.data)

        } else props.showAlert("" + (repos.message || repos), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const handleClose = () => {
    companyName(null)
    setOpenLocationModal(false);

  }

  const closeJDModel = () => setOpenJDModel(false);

  const OpenLocationModal = (value) => {

    setOpenLocationModal(true)

    let apiURL = process.env.REACT_APP_API_URL + "/officelocations/getCompanyCoordinates/" + value.latitude + "/" + value.longitude;
    let apiParams = {
      method: "GET",
      headers: {
        authtoken: localStorage.getItem("loggedintoken")
      }

    };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          // console.log(repos.data)
          setCompanyCoordinates(repos.data)

        } else props.showAlert("" + (repos.message || repos), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));

  }


  const changeRound = async (intvwId) => {
    //  console.log(intvwId)
    let apiURL = process.env.REACT_APP_API_URL + "/interview/getinterview/" + intvwId;

    let apiParams = {
      method: "GET",
      headers: {
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then(async (repos) => {
        if (repos.data) {
          //setCompanyName(repos.data.companyname + " - " + repos.data.jobId.officeName)
          await getOfficeVacancies(repos.data.companyname, repos.data.jobId.officeName)
          //console.log(repos.data)
          setInterviewId(repos.data._id);
          setName(repos.data.name)
          setInterViewerName(repos.data.interviewername === "" ? user.name : repos.data.interviewername);
          setInterViewDate(repos.data.interviewdate || new Date().toLocaleDateString());
          repos.data.interviewtime ? ((repos.data.interviewtime).length < 6 ? setInterViewTime((repos.data.interviewtime)) : setInterViewTime(new Date((repos.data.interviewtime)).toTimeString().slice(0, 5))) : setInterViewTime(new Date(new Date()).toTimeString().slice(0, 5));

          if (repos.data.interviewdate && repos.data.interviewtime) {

            let time = parseInt(parseInt(repos.data.interviewtime.split(':')[0]) * 60 + parseInt(repos.data.interviewtime.split(':')[1]) + 330);
            let interviewDateTime = new Date(new Date(new Date(repos.data.interviewdate).toDateString()).setMinutes(time)).toISOString().slice(0, 16);

            setTimeDate(interviewDateTime)
          }
          else {
            setTimeDate(new Date((new Date()).setMinutes(((new Date()).getMinutes() + 330))).toISOString().slice(0, 16))
          }
          setRound(repos.data.rounds);
          setInterViewLocation(repos.data.location === "undefined" ? "" : repos.data.location);
          // setStatus(repos.data.status);
          setFeedback("")
          setPrevFeedback(repos.data.feedback === "undefined" ? "" : repos.data.feedback)
          setBookMark(repos.data.bookmark === undefined ? false : repos.data.bookmark)
          setBookMarkCmts(repos.data.bookmarkcomment === "undefined" ? "" : repos.data.bookmarkcomment)
          setResult(repos.data.status)
          setRoundResult(repos.data.status)
          setMobile(repos.data.mobile)

          setCmr(repos.data.communicationRating === "undefined" ? "" : parseInt(repos.data.communicationRating))
          setEgr(repos.data.englishRating === "undefined" ? "" : parseInt(repos.data.englishRating))
          setJobId(repos.data.jobId._id)
          setJobTitle(repos.data.jobtitle)
          setHRName(repos.data.hrname)
          if (repos.data.rounds === "Client Round") {
            setNextInterviewDate(new Date((new Date(new Date().toDateString())).setMinutes(930)).toISOString().slice(0, 16))
          }
          else if (Number(user.accesstype) >= 3) {
            setNextInterviewDate(new Date(new Date(new Date().toDateString()).setMinutes(2490)).toISOString().slice(0, 16))
          }
          else {
            setNextInterviewDate(new Date((new Date()).setMinutes(((new Date()).getMinutes() + 330))).toISOString().slice(0, 16))
          }

          //console.log(repos.data)
        } else props.showAlert("" + (repos.message || repos), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));

  }

  const updateLanguage = (lang) => {

    var newLanguageValue = (((language.length > 0 && language.lastIndexOf(",") === language.length - 1) ? language.substring(0, language.length - 1) : language) + lang);
    setLanguage(((newLanguageValue.length > 0 && newLanguageValue.indexOf(",") === 0) ? newLanguageValue.substring(1, newLanguageValue.length - 1) : newLanguageValue));
  }

  const getLanguages = async () => {
    if (!props.interview?.applicantid) return;

    const url = `${process.env.REACT_APP_API_URL}/applicants/languages/${props.interview.applicantid}`;
    const res = await fetchData(url);

    if (!res?.data) {
      setLanguage(""); setPreviousCurrent(""); setExpectedSalary("");
      setCity(""); setArea(""); setEducation(""); setResumeUrl("");
      setExpYears(0); setExpMonths(0); setNoticePeriod(0);
      return;
    }

    const data = res.data;

    setLanguage(getValue(data.languages));
    setPreviousCurrent(getValue(data.currentSalary));
    setExpectedSalary(getValue(data.expectedSalary));
    setCity(getValue(data.city));
    setArea(getValue(data.area));
    setEducation(getValue(data.education));
    setResumeUrl(getValue(data.resumeUrl));
    setExpYears(Math.floor((data.experience || 0) / 12));
    setExpMonths((data.experience || 0) % 12);
    setNoticePeriod(getValue(data.noticePeriod, 0));

    const prefs = data.preferences ? JSON.parse(data.preferences) : {};
    Object.keys(preferencesMap).forEach(key => setPreference(key, prefs[key] ?? true));
  };


  const timer = async (action) => {
    if (!props.interview?.id) return; // Early exit if no interview

    const url = `${process.env.REACT_APP_API_URL}/interview/timer/${props.interview.id}/${action}`;

    const data = await fetchData(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authtoken: localStorage.getItem("loggedintoken"),
      },
    });

    // Optional: sync UI timer from backend
    // if (data?.timeSpent) setTimeSpent(data.timeSpent);
  };



  const getInterviewRounds = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/getscheduleinterview/" + applicantId + "/" + jobId;
    let apiParams = {
      method: "GET",
      headers: {
        authtoken: localStorage.getItem("loggedintoken")
      }

    };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {

          setCandidateRounds(repos.data)

          if (repos.data.length > 0) { changeRound(repos.data[repos.data.length - 1]._id) }

        }
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const getOfficeVacancies = async (company, office) => {
    let apiURL = process.env.REACT_APP_API_URL + "/jobs/vacancies?company=" + company + "&office=" + office;
    let apiParams = {
      method: "GET",
      headers: {
        authtoken: localStorage.getItem("loggedintoken")
      },
    };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {

          setVacancies(repos.data);
          if (repos.data.length > 0) {

            setJobId(repos.data && repos.data[0]._id);
            setJobTitle(repos.data && repos.data[0].jobtitle);
            setJobDescription(repos.data && repos.data[0].jobdescription);
            setCandidatePreference(repos.data && repos.data[0].preferences);
            setKeySkills(repos.data && repos.data[0].skills);
            setJobExperience(repos.data && parseInt(repos.data[0].minexpmonths))
            setMapUrl(repos.data && repos.data[0].mapUrl);
            setJobsDataProps(repos.data && repos.data[0])
            setCompanyName(repos.data && repos.data[0].companyname + " - " + repos.data[0].officeName);

          }
        } else props.showAlert("" + (repos.message || repos), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const today = new Date()
  const tomorrow = new Date().getDay() == 6 ? new Date(today + 24 * 60 * 60) : new Date(new Date(today))


  const nextRound = async () => {
    if (!props.interview?.applicantid) {
      props.showAlert("Applicant Id not found!", "error");
      return;
    }
    if (props.interview?.rounds === (Number(user.accesstype) >= 3 ? "Client Round" : "Verification")) {
      props.showAlert(`Attempting to create duplicate ${props.interview?.rounds}!`, "error");
      return;
    }

    if (companyName?.split(" - ").length < 2) {
      props.showAlert("Company not Selected!", "error");
      return;
    }

    if (!jobId) {
      props.showAlert("Vacancy not Selected!", "error");
      return;
    }

    const apiURL = `${process.env.REACT_APP_API_URL}/interview/applyinterview/${props.interview.applicantid}`;

    const payload = {
      name: props.interview.name,
      email: props.interview.mail,
      mobile: props.interview.mobile,
      jobid: jobId,
      jobtitle: jobTitle,
      hrname: props.interview.hrname,
      feedback: encodeURIComponent(
        `${user.name} [${new Date().toLocaleString()}]:\n${feedback}\n${props.interview.feedback || ""}\n`
      ),
      companyname: companyName?.split(" - ")[0],
      reference: props.interview.reference === "undefined" ? "" : props.interview.reference,
      interviewername: Number(user.accesstype) >= 3 ? "Client Interviewer" : "",
      round: Number(user.accesstype) >= 3 ? "Client Round" : "Verification",
      interviewdate: nextinterviewDate,
      interviewtime: nextinterviewDate.split('T')[1],
      location: Number(user.accesstype) >= 3 ? "" : "Mobile Call",
      createdbyid: user._id,
      createdbyname: user.name,
    };

    try {
      const data = await fetchData(apiURL, {
        method: "POST",
        headers: { authtoken: localStorage.getItem("loggedintoken") },
        body: JSON.stringify(payload),
      });

      if (data?.data) {
        if (whatsappStatus) WhatsappMsg();
        if (sendEmail) SendEmail();

        props.showAlert("Interview round created for applicant", "info");
      } else {
        props.showAlert(data?.message || "Already applied for this job", "error");
      }
    } catch (err) {
      props.showAlert(String(err), "error");
    }
  };


  const AddData = async () => {

    let success = await checkduplicate(referalName, referalNumber, referalGender)

    if (success === true) {
      uploadedCount.current = uploadedCount.current + 1
    }
  };


  const checkduplicate = async (name, mobile, gender) => {
    if (!mobile || mobile.length < 10) {
      props.showAlert("Mobile number length is below 10 digits!", "error");
      return false;
    }

    const phone = mobile.toString().replace(/-/g, '').slice(-10);
    const apiURL = `${process.env.REACT_APP_API_URL}/applicants/phone/${phone}`;

    try {
      const res = await apiFetch(apiURL, { method: "GET" });
      const data = res.status === 200 ? await res.json() : await res.text();

      if (data?.data) {
        props.showAlert(`${data.data.name} registered with ${data.data.mobile} already!`, "info");
        setReferalName("");
        setReferalNumber("");
        setReferalGender("male");
        return false;
      } else {
        await addApplicant(name, mobile, gender); // ensure addApplicant is async
        return true;
      }
    } catch (err) {
      props.showAlert(String(err), "error");
      return false;
    }
  };




  const addApplicant = (name, mobile, gender) => {

    let apiURL = process.env.REACT_APP_API_URL + "/applicants/addapplicant";
    let apiParams = {
      method: "POST",
      headers: {
        name: name,
        mobile: mobile,
        gender: gender,
        jobid: jobId,
        jobtitle: jobTitle,
        companyname: companyName && companyName.split(" - ")[0],
        reference: encodeURIComponent("Candidate Referal: " + name + " - " + mobile),
        createdbyid: user._id,
        createdbyname: user.name,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    // console.log(apiParams)
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          //setOutputMsg([...outputMsg,"\n"+name+" - "+mobile+" added successfully!\n"]);
          applyJob(repos.data)
        } else { props.showAlert((repos.message || repos), "error") }
      })
      .catch((err) => { props.showAlert(('' + err), "error") })
  }


  const handleUpload = async (e) => {
    var file = e.target.files[0] //the file
    var reader = new FileReader() //this for convert to Base64 
    reader.readAsDataURL(e.target.files[0]) //start conversion...
    reader.onload = function (e) { //.. once finished..
      var rawLog = reader.result.split(',')[1]; //extract only thee file data part
      var dataSend = { dataReq: { data: rawLog, name: name[0].toUpperCase() + name.slice(1), type: file.type }, fname: "uploadFilesToGoogleDrive" }; //preapre info to send to API
      apiFetch(process.env.REACT_APP_GOOGLEDRIVE_URL, //your AppsScript URL
        { method: "POST", body: JSON.stringify(dataSend) }) //send to Api
        .then(res => res.json()).then((data) => {
          //See response
          RetrieveResume(data)
          props.showAlert("Resume Uploaded Successfully", "success")

        }).catch(e => console.log(e)) // Or Error in console
    }

  }
  const RetrieveResume = (data) => {

    let apiURL = process.env.REACT_APP_API_URL + "/applicants/saveResumeUrl/" + applicantId;
    let apiParams = {
      method: "POST",
      headers: {
        resumeurl: data.url,
        authtoken: localStorage.getItem("loggedintoken")
      }
    }
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setResumeUrl(data.url)
        }
      })
      .catch(e => console.log(e))
  }

  function renameFile(originalFile, newName) {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  }
  const applyJob = (applicant) => {
    // console.log(job)
    let applicantid = applicant._id
    let apiURL = process.env.REACT_APP_API_URL + "/interview/applyinterview/" + applicantid;
    let apiParams = {
      method: "POST",
      headers: {
        hrname: hrName,
        name: applicant.name,
        mobile: applicant.mobile,
        jobid: jobId,
        jobtitle: jobTitle,
        companyname: companyName && companyName.split(" - ")[0],
        round: round,
        interviewername: hrName,
        createdbyid: createdbyid,
        createdbyname: createdbyname,
        reference: encodeURIComponent("Candidate Referal: " + name + " - " + mobile),
        authtoken: localStorage.getItem("loggedintoken")
      },
    };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setReferalName("")
          setReferalNumber("")
          setReferalGender("male")
          // alert("Referral added Sucessfully!")
          props.showAlert("Referral added Sucessfully!", "success")
          //setOutputMsg([...outputMsg,"\nInterviwer assigned successfully!"]);
        } else {
          //setOutputMsg([...outputMsg,"\nFailed to assign interviewer!"]);
        };
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }
  const LoadSelectedJob = (job) => {

    setOpenApplicant(false);
    if (job) {
      setJobId(job);
      setOpenScheduler(true);
      getInterviewRounds()
    }
    else {
      setOpenScheduler(false);

      props.close(openNext);
    }
  }


  const sendWhatsapp = () => {

    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + props.interview.mobile.trim().replace(' ', '').substring(props.interview.mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Good Day " + name[0].toUpperCase() + name.slice(1) + ",%0a%0aI am trying to reach you for a job vacancy. " + mobileStatus + "%0a%0aKindly call me back if interested to apply.%0a%0aFollow us on LinkedIn by clicking https://www.linkedin.com/company/bizi-bees-outsourcing"

    const newWindow = window.open(apiURL, '_blank')

  }

  const WhatsappMsg = () => {

    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + props.interview.mobile.trim().replace(' ', '').substring(props.interview.mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Congratulations " + name[0].toUpperCase() + name.slice(1) + ",%0a%0aYou have cleared the HR Screening round.%0a%0aPlease stay in touch for further updates.%0a%0aFollow us on LinkedIn by clicking https://www.linkedin.com/company/bizi-bees-outsourcing";


    const newWindow = window.open(apiURL, '_blank')
    //WhatsappMsgSupervisor();


  }

  const WhatsappRejectedCandidates = () => {

    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + props.interview.mobile.trim().replace(' ', '').substring(props.interview.mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Dear " + name[0].toUpperCase() + name.slice(1) + ",%0a%0aIt was a pleasure talking to you!%0a%0aPlease stay updated on the latest vacancies by following us on our LinkedIn Page by clicking https://www.linkedin.com/company/bizi-bees-outsourcing";


    const newWindow = window.open(apiURL, '_blank')
    //WhatsappMsgSupervisor();


  }

  const WhatsappMsgSupervisor = () => {

    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + user.reportingmobile + "&type=phone_number&app_absent=0&text=" + name[0].toUpperCase() + name.slice(1) + " has cleared the HR Screening round.%0a%0aPlease call the candidate on " + props.interview.mobile.trim().replace(' ', '').substring(props.interview.mobile.trim().replace(' ', '').length - 10) + " and conduct verification round if applicable.";


    const newWindow = window.open(apiURL, '_blank')

  }

  const SendMapLocation = () => {
    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + props.interview.mobile.trim().replace(' ', '').substring(props.interview.mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Good Day " + name[0].toUpperCase() + name.slice(1) + ",%0a%0aYour interview will be conducted at the below location. %0a%0a " + mapUrl + " %0a%0aKindly carry your resume hard copy and mention \"Bizi Bees\" on top of your resume without fail.%0a%0aPlease call me back on " + user.phone + " if any queries.%0a%0aFollow us on LinkedIn by clicking https://www.linkedin.com/company/bizi-bees-outsourcing"

    const newWindow = window.open(apiURL, '_blank')

  }

  const SendJD = async () => {

    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + props.interview.mobile.trim().replace(' ', '').substring(props.interview.mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Good Day " + name[0].toUpperCase() + name.slice(1) + ",%0a%0aBelow is the Job Description and Skill Sets Required for the job discussed. %0a%0aJob Description:%0a" + jobDescription.split('\n').map(line => line).join('%0a') + "%0a%0aSkills Required:%0a" + keySkills.split('\n').map(line => line).join('%0a') + "%0a%0aPlease call me back on " + user.phone + " if any queries.%0a%0aFollow us on LinkedIn by clicking https://www.linkedin.com/company/bizi-bees-outsourcing"

    const newWindow = window.open(apiURL.replace('%0a,', '%0a'), '_blank')

  }

  const SendEmail = () => {
    setTotalExperience(parseInt(expYears * 12) + parseInt(expMonth));
    setOpenEmailTemplate(true)

  }


  const showApplicant = () => {
    setOpenScheduler(false)
    setOpenApplicant(true)
  }


  const joinedRound = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/applyinterview/" + props.interview.applicantid;
    let apiParams = {
      method: "POST",
      headers: {
        name: props.interview.name,
        email: props.interview.mail,
        mobile: props.interview.mobile,
        jobid: jobId,
        jobtitle: jobTitle,
        hrname: props.interview.hrname,
        reference: props.interview.reference == "undefined" ? "" : props.interview.reference,
        feedback: encodeURIComponent(user.name + " [" + new Date().toLocaleString() + "]:\n" + feedback + "\n" + (props.interview.feedback || "") + "\n"),
        companyname: companyName && companyName.split(" - ")[0],
        interviewername: Number(user.accesstype) >= 3 ? "Client Interviewer" : "",
        round: "Joined",
        interviewdate: nextinterviewDate,
        interviewtime: nextinterviewDate.split('T')[1],
        location: "",
        status: "Joined",
        createdbyid: user._id,
        createdbyname: user.name,
        authtoken: localStorage.getItem("loggedintoken")
      },
    };
    // console.log(apiParams)
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {


          setTimeout(() => {
            props.showAlert("Applicant has been Marked as Joined", "info")
          }, 2000);



        } else props.showAlert((repos.message || repos || "already applied for this job"), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }


  const accessRestricted = Number(user.accesstype) < 3;

  const isFinalStatus =
    status === "Selected" ||
    status === "Joined" ||
    status === "Joined & Left" ||
    status === "Invoiced";

  const invalidCompany =
    !companyName ||
    companyName === "" ||
    companyName.split(" - ").length < 2 ||
    !companyName.split(" - ")[0] ||
    !companyName.split(" - ")[1];

  const restrictedRound =
    accessRestricted &&
    (round === "Verification" || hrName !== user.name);

  const hideUpdate =
    (accessRestricted && isFinalStatus) ||
    restrictedRound ||
    invalidCompany ||
    !jobId;

  const EditInterview = async () => {
    // --- Validation ---
    if (!companyName || companyName.split(" - ").length !== 2) {
      props.showAlert("Please select the Company for which Interviewed!", "error");
      return;
    }
    if (!jobId || jobId.length < 2) {
      props.showAlert("Please select the Job for which Interviewed!", "error");
      return;
    }
    if (result === "Next Round" && (!language || language.length < 2)) {
      props.showAlert("Please enter Candidate Languages!", "error");
      return;
    }
    if ((["Next Round", "Rejected", "Cancelled"].includes(result)) && egr.length === 0) {
      props.showAlert("Select English Rating", "error");
      return;
    }
    if ((["Next Round", "Rejected", "Cancelled"].includes(result)) && cmr.length === 0) {
      props.showAlert("Select Communication Rating", "error");
      return;
    }
    if (!feedback || feedback.trim().length < 5) {
      props.showAlert("Enter your feedback!", "error");
      return;
    }

    // --- Prepare feedback & bookmark ---
    let feedbackObj = "";
    let bookMarkObj = "";

    if (props.interview) {
      props.close(openNext);
      bookMarkObj =
        props.interview.bookmark !== bookMark
          ? bookMarkCmts
          : props.interview.bookmarkcomment && props.interview.bookmarkcomment !== "undefined"
            ? props.interview.bookmarkcomment
            : "";

      feedbackObj = encodeURIComponent(
        `${user.name} [${new Date().toLocaleString()}]:\n${feedback}\n` +
        (props.interview.bookmark !== bookMark
          ? bookMark
            ? `Bookmark added with comments: ${bookMarkObj}\n`
            : `Bookmark removed with comments: ${bookMarkObj}\n`
          : "") +
        (props.interview.feedback && props.interview.feedback !== "undefined"
          ? props.interview.feedback
          : "") +
        "\n"
      );
    } else {
      props.closeMsg();
    }

    // --- API Request ---
    const apiURL = `${process.env.REACT_APP_API_URL}/interview/editinterview/`;
    const apiParams = {
      method: "POST",
      headers: {
        applicantid: props.interview ? props.interview.applicantid : props.interviewMsg._id,
        interviewid: interviewId,
        interviewername: interViewerName,
        hrname: hrName,
        interviewdate: timeDate,
        interviewtime: timeDate.split("T")[1],
        rounds: round,
        location: encodeURIComponent(interViewLocation),
        companyname: companyName.split(" - ")[0],
        jobid: jobId,
        jobtitle: jobTitle,
        createdbyid: user._id,
        createdbyname: user.name,
        feedback: feedbackObj,
        bookmark: bookMark,
        bookmarkcomments: bookMarkObj,
        result: result,
        languages: language?.endsWith(",") ? language.slice(0, -1) : language,
        currentsalary: previousCurrent,
        expectedsalary: expectedSalary,
        preferences: JSON.stringify({
          voiceProcess, nonVoiceProcess, workFromHome, workFromOffice,
          partTime, fullTime, nightShift, dayShift,
          companyTransportDay, companyTransportNight, ownTransport, willingToRelocate
        }),
        city, area, education,
        experience: parseInt(expYears) * 12 + parseInt(expMonth),
        noticeperiod: noticePeriod ? parseInt(noticePeriod) : 0,
        communicationrating: cmr,
        englishrating: egr,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };

    try {
      const res = await apiFetch(apiURL, apiParams);
      const repos = res.status === 200 ? await res.json() : await res.text();


      if (repos.data) {
        // --- Handle notifications based on result ---
        if (result === "Next Round" && roundResult !== "Next Round") nextRound();
        else if (result === "Joined" && round !== "Joined") joinedRound();
        else if (whatsappStatus) {
          if (result === "Not Reachable") sendWhatsapp();
          else if (["Next Round", "Passed"].includes(result)) WhatsappMsg();
          else if (["Rejected", "Cancelled"].includes(result)) WhatsappRejectedCandidates();
        }

        props.showAlert("Interview Updated Successfully", "success");
      } else {
        props.showAlert(`${repos.message || repos}`, "error");
      }
      props.refresh();
    } catch (err) {
      props.showAlert(String(err), "error");
    }
  };




  const getCompanies = async () => {
    let apiURL = process.env.REACT_APP_API_URL + "/jobs/companies"
    let apiParams = {
      method: "GET",
      headers: {
        authtoken: localStorage.getItem("loggedintoken")
      },
    };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 531 ? window.logout() : res.status === 200 ? res.json() : res.text()))
      .then(async (repos) => {
        if (repos.data) {

          setCompanies(repos.data)
          //setCompanyName(repos.data[0].split(" - ").length === 2 ? repos.data[0] : null)
          await getOfficeVacancies(repos.data[0].split(" - ")[0], repos.data[0].split(" - ")[1])

        } else props.showAlert("" + (repos.message || repos), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const getUsers = async () => {
    let apiURL = process.env.REACT_APP_API_URL + "/users/getusers"
    let apiParams = {
      method: "GET",
      headers: {
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {

          //console.log(repos.data)
          setHRNames(repos.data)
        } else props.showAlert("" + (repos.message || repos), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const openJdModal = () => {
    setOpenJDModel(true)
  }


  //Getting Locations from Location Tab and mapping to get area
  const areaLoc = (areasOfinterview)?.map((loc) => loc.area);
  const hrnames = (hRNames)?.map((hr) => hr.name);


  // const rowData = [];      

  var cols = [

    { field: 'id', headerName: 'id', hide: true },
    { field: 'company', headerName: 'Company', width: 150, },
    { field: 'office', headerName: 'Office', width: 150 },
    { field: 'distance', headerName: 'Distance(km)', width: 150, headerAlign: 'center', align: "center" },

  ];


  const rowData = (companyCoordinates || []).map((co) => {

    return {

      id: co._id,
      company: co.company,
      office: co.office,
      distance: parseInt(co.distance),

    };
  });



  return (
    <>
      <Modal
        open={openScheduler}
        onClose={props.handleCloseView}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: 'scroll', textAlign: "center" }}
      >
        <div id="schedule_interviews_Modal">
          <img id="popUpBackground1" src="n_291450.png" srcset="n_291450.png 1x, n_291450@2x.png 2x" />

          <img id="popUpBackground2" src="n_7973908.png" srcset="n_7973908.png 1x, n_7973908@2x.png 2x" />
          <div className="ScheduleInterviewBackground">
            <rect id="ScheduleInterviewBackground" rx="0" ry="0" x="0" y="0" width="539" height="100">
            </rect>
            <Timer style={{ width: "50px", height: "5%" }} class="ScheduleInterviewBackground" started={props.open} />
            <ReactInternetSpeedMeter
              txtSubHeading="Internet is too slow"
              outputType="empty"
              customClassName={null}
              txtMainHeading="Opps..."
              pingInterval={15000} // milliseconds 
              thresholdUnit='megabyte' // "byte" , "kilobyte", "megabyte" 
              threshold={10}
              imageUrl="/bizibees.jpeg"
              downloadSize="18800"  //bytes
              callbackFunctionOnNetworkDown={(speed) => `Internet speed is down ${speed}`}
              callbackFunctionOnNetworkTest={(speed) => setWifiSpeed(speed)}

            />
            <div style={{ zIndex: "10", position: "relative", color: wifiSpeed < 10 ? "red" : "white" }}>Internet speed: {wifiSpeed} mb/s</div>
          </div>
          <svg class="ScheduleTitle_PC">
            <linearGradient id="ScheduleTitle_PC" spreadMethod="pad" x1="0.436" x2="-0.378" y1="1" y2="-1.052">
              <stop offset="0" stop-color="#fff" stop-opacity="1"></stop>
              <stop offset="1" stop-color="#808080" stop-opacity="1"></stop>
            </linearGradient>
            <rect id="ScheduleTitle_PC" rx="17" ry="17" x="0" y="0" width="400" height="65">
            </rect>
          </svg>
          <div className='Schedule_CancelBtn'>
            <Button title="Close" id='Schedule_CancelBtn' size="small" variant="Standard" sx={{ bgcolor: "white", float: "right", right: 0, top: 0, position: "absolute", height: 28, width: 5 }} onClick={() => {
              if (props.open === true) {
                props.close(openNext); setOpenScheduler(false);
              } else if (props.openMsg === true) {
                props.closeMsg();
                setOpenScheduler(false);
              }
            }
            }> <CloseIcon style={{ height: "25px", width: "25px" }} /> </Button>
          </div>

          <div id="Candidate_Username_">
            <span><marquee>{name}</marquee></span>
          </div>
          <div id="Candidate_Mobile_">
            <span>{<a href={"tel:" + mobile}>{mobile}</a>}</span>
          </div>

          {status === "Applied" && props.interview.rounds === undefined ?
            <div className='Interview_Rounds_Hr'>
              <Autocomplete
                disablePortal
                id="txtRounds"
                freeSolo
                options={rounds}
                sx={{ width: 250 }}
                value={round || ""}
                onChange={(event, value) => setRound(value.label)}
                renderInput={(params) => <TextField {...params}
                  //className="BOXLEFT"
                  //sx={{minWidth: 420 }}
                  size="small" label="Interview Round"
                  value={round || ""}
                  onChange={(e) =>
                    setRound(e.target.value)
                  } />}
              />
            </div>
            :
            <div className='Hr_Rounds_1' style={{ textAlign: "center", fontFamily: 'Times New Roman' }}>{[...new Set(candidateRounds)].map(rnd => rnd._id === interviewId ? <b>{round}</b> : <input type="button" style={{ border: "1px solid", top: "231px", padding: "2px 6px", margin: "5px", borderRadius: "10px" }} onClick={() => { changeRound(rnd._id); }} value={rnd.rounds} />)}</div>
          }
          <div className='Interview_Hr_Names'>
            <Autocomplete
              disablePortal
              id="Interview_Hr_Names"
              freeSolo
              options={hrnames}
              sx={{ width: 250 }}
              disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
              value={hrName || ""}
              onChange={(event, value) => setHRName(value)}
              renderInput={(params) => <TextField {...params}
                InputProps={{
                  startAdornment:
                    <InputAdornment position="start"><AccountBoxIcon /></InputAdornment>,
                }}
                sx={{ width: 250 }}
                size="small" label="HR Name"
                disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
                value={hrName || ""}
                onChange={(e) => {
                  setHRName(e.target.value);
                }} />}
            />
          </div>

          <div className='Interview_Date_Time'>
            <small>{round !== "Joined" ? "Interview Date & Time: " : "Joined Date: "}</small><input type="datetime-local" format="dd-mm-yyyy" disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"} style={{ width: "250px", height: "50%", backgroundColor: "transparent", border: "1px solid", padding: "2px 6px" }} max={new Date().toISOString().slice(0, 16)} value={timeDate} onChange={(e) => setTimeDate(e.target.value)} />
          </div>

          <div className='Schedule_CompanyName'>
            <FormControl variant="outlined"

              sx={{ width: 250 }} size="small">
              <InputLabel id="companyName-label"><ApartmentIcon /> &nbsp; Company Name</InputLabel>
              <Select
                labelId="company-name-labell"
                id="Schedule_CompanyName"
                disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
                value={companyName}
                InputLabelProps={{ shrink: true }}
                // defaultValue={companyName}
                onChange={async (e) => {
                  //setCompanyName(e.target.value.split(" - ").length === 2 ? e.target.value : null)
                  await getOfficeVacancies(e.target.value.split(" - ")[0], e.target.value.split(" - ")[1]);
                }} >
                {
                  companies && companies.map((company) => <MenuItem key={company} value={company}>{company}</MenuItem>
                  )}

              </Select>
            </FormControl>

          </div>
          <div className='Resume_Upload_'>
            <FileUploadIcon style={{ marginLeft: "5px", color: "cornflowerblue" }} onClick={(e) => document.getElementById('candidateResume').click()} />
            <input id="candidateResume" type="file" placeholder="Upload Resume" style={{ display: "none" }} name="Resume" onChange={(e) => handleUpload(e)}></input>
            {resumeUrl && resumeUrl !== "" ? <FileDownloadIcon style={{ marginLeft: "5px", color: "cornflowerblue" }} onClick={(e) => document.getElementById('candidateResumeDownload').click()} /> : ""}
            {resumeUrl && resumeUrl !== "" ? <a id="candidateResumeDownload" style={{ display: "none" }} name="Resume" href={resumeUrl} target="_blank" ></a> : ""}
          </div>

          <div className='Schedule_Available_Job'>
            <FormControl variant="outlined" sx={{ width: 250 }} size="small" >
              <InputLabel id="vacancies-label"><WorkIcon /> &nbsp; Available Vacancies</InputLabel>
              <Select
                labelId="vacancies-labell"
                id="Schedule_Available_Job"
                disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
                value={jobId} onChange={(e) => {

                  setJobId(e.target.value);
                  setCandidatePreference(vacancies.filter(vacancy => vacancy._id === e.target.value)[0].preferences)
                  setJobTitle(vacancies.filter(vacancy => vacancy._id === e.target.value)[0].jobtitle);
                  setMapUrl(vacancies.filter(vacancy => vacancy._id === e.target.value)[0].mapUrl);
                  setCandidatePreference(vacancies.filter(vacancy => vacancy._id === e.target.value)[0].preferences)

                }} >

                {

                  vacancies && vacancies.map((vacancy) => <MenuItem value={vacancy._id}>{vacancy.jobtitle}</MenuItem>

                  )}
              </Select>
              {vacancies && vacancies.filter(vacancy => vacancy._id === jobId)[0]?.languages}
            </FormControl>

          </div>



          <div>
            <img id="_Office_location" src="location.png" srcset="location.png 1x, location@2x.png 2x" />
            <a href="#" id='Company_Send_location' onClick={() => SendMapLocation()}>Send Location</a>
          </div>


          <div>
            <img id="document" src="document.png" srcset="document.png 1x, document@2x.png 2x" />
            <a href="#" id="Sending_Company_JD" onClick={() => { SendJD(); }}>Send JD</a>
          </div>




          <div >
            <img id="view" src="view.png" srcset="view.png 1x, view@2x.png 2x" />
            <a href="#" id="View_Job_bg" onClick={() => openJdModal()}>View</a>
          </div>

          <div className='Interview_Locations'>
            <Autocomplete
              disablePortal
              id="Interview_Locations"
              freeSolo
              options={locations}
              sx={{ width: 250 }}
              disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
              value={interViewLocation || "Mobile Call"}
              onChange={(event, value) => setInterViewLocation(value.label)}
              renderInput={(params) => <TextField {...params}
                InputProps={{
                  startAdornment:
                    <InputAdornment position="start"> <LocationOnIcon /></InputAdornment>,
                }}

                sx={{ minWidth: 250 }}
                size="small"
                label={round !== "Joined" ? "Interview Location" : "Joined Location"}
                disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
                multiline
                value={interViewLocation || ""}
                onChange={(e) => {
                  setInterViewLocation(e.target.value);
                }} />}
            />
          </div>

          <div className='Interviews_Candidate_City'>
            <TextField
              InputProps={{
                startAdornment:
                  <InputAdornment position="start"><LocationCityIcon /></InputAdornment>,
              }}
              sx={{ width: 250 }} id="Interviews_Candidate_City" size="small" label="City" variant="outlined" value={city} onChange={(e) => {
                setCity(e.target.value);

              }} />

            <br />
            {(areasOfinterview || []).filter(rec => (rec.area || "").toLowerCase().trim() === (area || "").toLowerCase().trim()).length > 0 ?
              <div>
                <a href="#" onClick={() => OpenLocationModal((areasOfinterview || []).filter(rec => (rec.area || "").toLowerCase().trim() === (area || "").toLowerCase().trim())[0])}>Show Office Distances</a>
              </div> : ""}


          </div>

          <div className='Candidate_Area'>
            <Autocomplete
              disablePortal
              id="Candidate_Area"
              freeSolo
              options={areaLoc}
              sx={{ width: 250 }}
              value={area || ""}

              onChange={(event, value) => {
                setArea(value);
              }}
              renderInput={(params) => <TextField {...params}

                sx={{ width: 250 }}
                size="small" label="Area"
                value={area || ""}
                onChange={(e) => {
                  setArea(e.target.value);
                }} />}
            />
          </div>


          <div className='Candidate_Education'>
            <TextField
              sx={{ width: "300px", marginTop: "2px", }} id="Candidate_Education" size="small" label="Education" variant="outlined" value={education} onChange={(e) => {
                setEducation(e.target.value)
              }} />
          </div>



          <div className='Candidate_Languages'>
            <TextField

              sx={{ width: "350px", marginTop: "2px" }} id="Candidate_Languages" size="small" label="Languages" variant="outlined" value={language} onChange={(e) => {
                setLanguage(e.target.value.length > 0 && e.target.value.slice(0, 1) === "," ? language.substring(1, e.target.value.length) : e.target.value);

              }} />
            <div style={{ textAlign: "center", fontSize: "small", marginTop: "3px" }}>

              {(language || "").includes("English") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",English,")}>English</button>}
              {(language || "").includes("Hindi") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Hindi,")}>Hindi</button>}
              {(language || "").includes("Kannada") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Kannada,")}>Kannada</button>}
              {(language || "").includes("Urdu") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Urdu,")}>Urdu</button>}
              {(language || "").includes("Tamil") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Tamil,")}>Tamil</button>}
              {(language || "").includes("Telugu") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Telugu,")}>Telugu</button>}
              {(language || "").includes("Malayalam") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Malayalam,")}>Malayalam</button>}
              {(language || "").includes("Marathi") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Marathi,")}>Marathi</button>}
              {(language || "").includes("Punjabi") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Punjabi,")}>Punjabi</button>}
              {(language || "").includes("Bangla") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Bangla,")}>Bangla</button>}
              {(language || "").includes("Arabic") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Arabic,")}>Arabic</button>}
              {(language || "").includes("French") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",French,")}>French</button>}
              {(language || "").includes("Spanish") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Spanish,")}>Spanish</button>}
              {(language || "").includes("Russian") ? "" : <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => updateLanguage(",Russian,")}>Russian</button>}
              <button style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} onClick={e => setLanguage("")}>Clear</button>
              <br /></div>
          </div>



          <WorkPreferencesScheduleInterviewUI type={props.type} preferences={{ voiceProcess, nonVoiceProcess, fullTime, partTime, workFromOffice, workFromHome, dayShift, nightShift, companyTransportDay, companyTransportNight, ownTransport }} highlight={{ candidatePreference }} setPreference={(key, value) => setPreference(key, value)} />


          <div className='Willing_to_Relocate_Preference'>
            <input type="checkbox" id="Willing_to_Relocate_Preference" name="Willing_to_Relocate_Preference" checked={willingToRelocate} onChange={() => setWillingToRelocate(!willingToRelocate)} />
          </div>
          <label id='Willing_to_Relocate_lbl_' for="chkWillingtorelocate" style={{ color: willingToRelocate ? "red" : "black" }}>Willing To Relocate</label>


          <div className='Refer_Name_txt'>
            <TextField
              sx={{ width: "125px", marginTop: "2px" }} id="Refer_Name_txt" size="small" label="Refer Name" variant="outlined" value={referalName} onChange={(e) => {
                setReferalName(e.target.value)
              }} />
          </div>


          <div className='Refer_Mobile_txt'>
            <TextField
              sx={{ width: "125px", marginTop: "2px" }} id="Refer_Mobile_txt" size="small" label="Refer Mobile" variant="outlined" value={referalNumber} onChange={(e) => {
                setReferalNumber(e.target.value)

              }} />
          </div>

          <div className='Candidate_Gender_txt'>
            <FormControl variant="outlined" sx={{ width: 125, marginTop: "2px" }} size="small"  >
              <InputLabel id="demo-Candidate_Gender_txt-select-label"  >Gender</InputLabel>
              <Select
                labelId="demo-simple-select-labell"
                id="Candidate_Gender_txt"

                value={referalGender} onChange={(e) => {

                  setReferalGender(e.target.value);

                }} >

                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="others">Others</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="Add_Referal_Candidate">
            <input type="button" style={{ width: "30px", height: "45px" }} onClick={AddData} value="+" />
          </div>
          <div className='Interviewer_Name_txt'>
            <Autocomplete
              disablePortal
              id="Interviewer_Name_txt"
              freeSolo
              options={hrnames}
              sx={{ width: 270 }}
              value={interViewerName || ""}
              disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
              onChange={(event, value) => setInterViewerName(value)}
              renderInput={(params) => <TextField {...params}

                sx={{ width: 270 }}
                size="small" label="Interviewer Name"
                disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
                value={interViewerName || ""}
                onChange={(e) => {
                  setInterViewerName(e.target.value);
                }} />}
            />
          </div>

          {Number(user.accesstype) < 3 && (status === "Selected" || status === "Joined" || status === "Joined & Left" || status === "Invoiced") ? <div className='Applied_lbl' style={{ textAlign: "center", color: "cornflowerblue", fontWeight: "bold" }}><h4>{status}</h4></div> :
            <div style={{ textAlign: "center", color: "cornflowerblue", fontWeight: "bold" }} className='Interview_result_txt'><FormControl variant="outlined" sx={{ minWidth: 270 }} size="small"  >
              {(roundResult && (roundResult === "Next Round" || roundResult === "Passed")) ? "Interview Result:Passed" :
                <><InputLabel id="demo-simple-select-label">Interview Result</InputLabel>
                  <Select
                    labelId="demo-simple-select-labell"

                    id="demo-simple-select"

                    value={result}
                    onChange={(e) => {
                      setResult(e.target.value);
                    }} >
                    {round !== "Joined" ? <MenuItem value="Applied">Applied</MenuItem> : <></>}
                    {round !== "Joined" ? <MenuItem value="Scheduled">Scheduled</MenuItem> : <></>}
                    {round !== "Joined" ? <MenuItem value="Not Reachable">Not Reachable</MenuItem> : <></>}
                    {round !== "Joined" ? <MenuItem value="Rejected">Failed</MenuItem> : <></>}
                    {round !== "Joined" && round !== "Client Round" ? <MenuItem value="Next Round">Passed</MenuItem> : <></>}
                    {round !== "Joined" ? <MenuItem value="Cancelled">Cancelled</MenuItem> : <></>}
                    {round === "Client Round" ? <MenuItem value="Selected">Selected</MenuItem> : <></>}
                    {round === "Client Round" ? <MenuItem value="Not Joined">Selected & Not Joined</MenuItem> : <></>}
                    {round === "Client Round" ? <MenuItem value="Joined">Joined</MenuItem> : <></>}
                    {round === "Joined" ? <MenuItem value="Joined & Left">Joined & Left</MenuItem> : <></>}
                    {round === "Joined" ? <MenuItem value="Invoiced">Invoiced</MenuItem> : <></>}

                  </Select></>}
            </FormControl>
            </div>
          }


          {result === "Next Round" ? <div id="Next_Round_On_lbl">
            <span>{result === "Next Round" ? "Next Round On: " : (result === "Joined" && props.interview.status !== "Joined") ? "Joined Date" : ""}</span>
          </div> : ""}
          <div className='NextInterviewDateTime'>
            {result === "Next Round" || (result === "Joined" && props.interview.status !== "Joined") ? <input type="datetime-local" id='NextInterviewDateTime' format="dd-mm-yyyy" style={{ width: "180px", height: "35px", backgroundColor: "transparent", border: "1px solid", padding: "2px 6px" }} disabled={(roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"} value={nextinterviewDate} onChange={(e) => setNextInterviewDate(e.target.value)} /> : ""}
          </div>

          <div className='Suggestion_for_Interview'>
            {(() => {
              const options = {
                "Not Reachable": [
                  { label: "Switched Off", feedback: "Switched Off", status: "Your number is switched off." },
                  { label: "Not received", feedback: "Not received call", status: "Your number is not reachable." },
                  { label: "Out of network", feedback: "Out of network", status: "Your number is out of network." },
                  { label: "Another call", feedback: "On another call", status: "Your number is busy on another call." },
                  { label: "Disconnecting", feedback: "Disconnecting", status: "We are unable to connect with you." },
                  { label: "Other Person Picked", feedback: "Some other person received the call.", status: "Some other person received our call." },
                ],
                "Rejected": [
                  { label: "Worst Comm", feedback: "Worst Communication" },
                  { label: "Poor Comm", feedback: "Poor Communication" },
                  { label: "WFH", feedback: "Needs work from home" },
                  { label: "Part Time", feedback: "Needs Part Time Job" },
                  { label: "Non Voice", feedback: "Needs non Voice Job" },
                  { label: "High salary", feedback: "Needs High salary" },
                  { label: "Not interested", feedback: "Not interested" },
                ],
                "Next Round": [
                  { label: "Voice", feedback: "Selected for Voice Process." },
                  { label: "Non-Voice", feedback: "Selected for Non-Voice Process." },
                  { label: "WFH", feedback: "Selected for work from home Process." },
                ],
                "Cancelled": [
                  { label: "Not Interested", feedback: "Not interested" },
                  { label: "Duplicate", feedback: "Duplicate Record" },
                ],
              };

              return (options[result] || []).map((opt, idx) => (
                <button
                  key={idx}
                  style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }}
                  onClick={() => {
                    // Handle toggling for Next Round buttons
                    if (result === "Next Round") {
                      setFeedback(prev =>
                        prev.includes(opt.feedback)
                          ? prev.replace(` ${opt.feedback}`, "").replace(opt.feedback, "")
                          : (prev === "" ? "" : prev + " ") + opt.feedback
                      );
                    } else {
                      setFeedback(opt.feedback);
                    }

                    // Set mobileStatus if defined
                    if (opt.status) setMobileStatus(opt.status);
                  }}
                >
                  {opt.label}
                </button>
              ));
            })()}

            {/* Clear button */}
            {(result === "Rejected" || result === "Not Reachable" || result === "Cancelled" || result === "Next Round") && (
              <button
                style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }}
                onClick={() => {
                  setFeedback("");
                  setMobileStatus(""); // Reset mobileStatus too
                }}
              >
                Clear
              </button>
            )}
          </div>

          <div className='English_Rating_txt'>
            <FormControl variant="outlined" sx={{ width: 270, marginTop: "2px" }} size="small"  >
              <InputLabel id="English_Rating_txt-label" > English Ratings</InputLabel>
              <Select
                labelId="demo-simple-select-labell"
                id="English_Rating_txt"

                value={egr} onChange={(e) => {

                  setEgr(e.target.value);

                }} >

                <MenuItem value={5}>A - Excellent</MenuItem>
                <MenuItem value={4}>B - Good</MenuItem>
                <MenuItem value={3}>C - Average</MenuItem>
                <MenuItem value={2}>D - Bad</MenuItem>
                <MenuItem value={1}>E - Pathetic</MenuItem>
              </Select>
            </FormControl>

          </div>

          <div className='Communication_Rating_txt'>
            <FormControl variant="outlined" sx={{ width: 270, marginTop: "2px" }} size="small"  >
              <InputLabel id="Communication_Rating_txt-label"  >Communication Ratings</InputLabel>
              <Select
                labelId="demo-simple-select-labell"
                id="Communication_Rating_txt"

                value={cmr} onChange={(e) => {

                  setCmr(e.target.value);

                }} >

                <MenuItem value={5}>A - Excellent</MenuItem>
                <MenuItem value={4}>B - Good</MenuItem>
                <MenuItem value={3}>C - Average</MenuItem>
                <MenuItem value={2}>D - Bad</MenuItem>
                <MenuItem value={1}>E - Pathetic</MenuItem>
              </Select>
            </FormControl>
          </div>


          <div className='Previous_Feedback_txt'>
            <TextField
              id="outlined-multiline-flexible"
              //className="BOXLEFT"
              sx={{ width: 290 }}
              style={{ marginRight: "20px" }}
              size="small"
              label="Previous Feedback"
              multiline
              rows={4}
              value={prevfeedback || ""}
            //    onChange={(e)=> {
            //   setPrevFeedback(e.target.value);
            // }} 
            />
          </div>

          <div className='Enter_your_feedback_txt'>
            <TextField
              id="Enter_your_feedback_txt"
              sx={{ width: 290, marginBottom: "0px" }}
              size="small"
              label="Enter Your Feedback"
              multiline
              rows={2}
              value={feedback || ""}
              onChange={(e) => {
                setFeedback(e.target.value);
              }} />
          </div>

          <div className='Bookmark_Chck'>
            <input type="checkbox" id="Bookmark_Chck" name="bookmark" checked={bookMark} onChange={() => setBookMark(!bookMark)} />
          </div>
          <div id="Bookmark_lbl">
            <span>Bookmark</span>
          </div>

          <div className='Schedule_Bookmarkcmts'>
            <input type="text" style={{ width: "175px", height: "50px", border: "1px solid", padding: "2px 6px" }} id="Schedule_Bookmarkcmts" name="bookmarkComments" placeholder="Bookmark Comments" disabled={(!props.interview && !bookMark) || (!props.interview.bookmark && !bookMark) || props.interview.bookmark === bookMark} value={bookMarkCmts} onChange={(e) => setBookMarkCmts(e.target.value)} />
          </div>


          <div className='Open_Next_txt'>
            <input type="checkbox" id="Open_Next_txt" name="chkOpenNext" checked={openNext} onChange={() => setOpenNext(!openNext)} />
          </div>
          <div id="Open_Next_lbl">
            <span>Open Next</span>
          </div>

          {(result === 'Not Reachable' || result === 'Next Round' || result === 'Rejected' || result === 'Cancelled') ? <div className='WhatsApp_Status_Chck'>
            <input type="checkbox" id="WhatsApp_Status_Chck" name="chkWhatsapp" checked={whatsappStatus} onChange={() => setWhatsappStatus(!whatsappStatus)} />
          </div> : ""}

          {(result === 'Not Reachable' || result === 'Next Round' || result === 'Rejected' || result === 'Cancelled') ? <div id="WhatsApp_Status_lbl">
            <span>WhatsApp Status</span>
          </div> : ""}

          <div className='Send_Email_txt'>
            {companyName && companyName.split(" - ")[0] === "Focus Edumatics" ? <input type="button" id="Send_Email_txt" name="chkEmail" style={{ border: "1px solid", padding: "2px 6px" }} value="Send Email" onClick={() => { setSendEmail(!sendEmail); SendEmail() }} /> : ""}
          </div>

          <div className="Update_btn_1">
            {hideUpdate ? null : (
              <Button
                type="reset"
                title="Update"
                disabled={!result}
                variant="contained"
                onClick={EditInterview}
              >
                Update
              </Button>
            )}
          </div>

          <svg class="ScheduleInterviewPointer1">
            <ellipse id="ScheduleInterviewPointer1" rx="7" ry="7" cx="7" cy="7">
            </ellipse>
          </svg>

          <svg class="ScheduleInterviewProgress1" viewBox="0 0 234 1">
            <path id="ScheduleInterviewProgress1" d="M 0 0 L 234 0">
            </path>
          </svg>

          <svg class="ScheduleInterviewApplicantPointer">
            <ellipse closeFull={() => { setOpenScheduler(false); props.close(openNext) }} onClick={() => showApplicant()} id="ScheduleInterviewApplicantPointer" rx="7" ry="7" cx="7" cy="7">
            </ellipse>
          </svg>

          <svg class="SchedulePath_1" viewBox="18.881 193.052 389.968 2677.099">
            <path id="SchedulePath_1" d="M 85.56208801269531 193.6184234619141 L 87.39723968505859 193.6184234619141 L 103.7058486938477 225.7629699707031 L 408.8490905761719 225.7629699707031 L 408.8490905761719 2870.150390625 L 213.97705078125 2870.150390625 L 19.56823921203613 2870.150390625 L 18.88072967529297 226.8946838378906 L 71.920654296875 225.7629699707031 L 86.46845245361328 193.0517578125">
            </path>
          </svg>

          <img id="ScheduleInterviewcalendar1" src="calendar1.png" srcset="calendar1.png 1x, calendar1@2x.png 2x" />

          <img closeFull={() => { setOpenScheduler(false); props.close(openNext) }} onClick={() => showApplicant()} id="ScheduleInterviewuserPage" src="user4.png" srcset="user4.png 1x, user4@2x.png 2x" />

        </div>
      </Modal>





      {/* Modal for nearby locations */}
      <Modal
        open={openLocationModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={NearbyLocations}>
          <div>

            <h4 className="fnt2"><b>NearBy Locations</b>

              <Button title="Close" size="small" variant="Standard" sx={{ bgcolor: "red", float: "right", right: 0, top: 0, position: "absolute", height: 28, width: 5 }} onClick={() => handleClose()} > <CloseIcon style={{ height: "25px", width: "25px" }} /> </Button>
            </h4>
          </div>

          <div style={{ height: 750, width: '100%', margin: "0px" }}>
            <DataGrid
              initialState={{
                sorting: {
                  sortModel: [{ field: 'distance', sort: 'asc' }],
                },
              }}
              rows={rowData}
              columns={cols}
              components={{
                Toolbar: GridToolbar,
              }}

            />
          </div>

        </Box>
      </Modal>

      {/* <ApplicantPopup open={openApplicant} showAlert={props.showAlert} applicantId={applicantId} close={job=>{
     
      setJobId(job);
      if(jobId===job){
        LoadSelectedJob(jobId)
      }
     }}  
    /> */}

      <InterviewApplicantPopup open={openApplicant} highlight={{ candidatePreference }} showAlert={props.showAlert} applicantId={applicantId} close={job => {
        setJobId(job);
        if (jobId === job) {
          LoadSelectedJob(jobId)
        }
      }} />

      <EditJobs type={"View"} openJobs={openJDModel} jobsData={jobsDataProps} showAlert={props.showAlert} close={closeJDModel} />

      <EmailTemplatesPopup jobTitle={jobTitle} toEmail={mail} open={openEmailTemplate} showAlert={props.showAlert} applicantId={applicantId} applicantName={name} applicant={{ area, previousCurrent, expectedSalary, mobile, noticePeriod, totalExperience }} close={() => setOpenEmailTemplate(false)}

      />
    </>
  )
}

export default ScheduleInterviewUI